import { IErrorTypeHandlerMap, TrackErrorE11ErrorHandler } from '@engineering11/web-api-error'
import { NotificationE11ErrorHandler } from './notification-error.handler'

export const ISD_ERRORS = Object.freeze({ SELLER_REGISTRATION_FAILED: 'isd/seller-registration-failed' })

export const errorHandlerOverrides: IErrorTypeHandlerMap = { [ISD_ERRORS.SELLER_REGISTRATION_FAILED]: NotificationE11ErrorHandler }
